var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 150,
    viewBox: "0 0 124 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.249 96.6782C153.11 28.9228 80.2051 6.90611 58.3804 1.70873C36.5557 -3.48866 22.8283 3.98982 7.96712 33.4186C-6.89403 62.8473 5.11716 105.731 8.69084 124.121C12.2645 142.511 56.6726 181.372 110.249 96.6782Z",
    fill: "#ED98A6",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkVector);
export default __webpack_public_path__ + "static/media/pink-vector.31b2b739.svg";
export { ForwardRef as ReactComponent };